import { Link } from 'react-router-dom';
import { webtoons } from '@/mocks/webtoons';

const picks = webtoons.filter((w) => !w.featured && !w.latest).slice(0, 4);

export default function EditorPickSection() {
  return (
    <section className="py-10 md:py-14 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="font-heading text-xl md:text-2xl text-foreground-950">
            编辑精选
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {picks.map((webtoon) => (
            <Link
              key={webtoon.id}
              to={`/article/${webtoon.id}`}
              className="flex gap-4 p-4 rounded-xl bg-background-100 hover:bg-primary-50 transition-colors group cursor-pointer"
            >
              <div className="w-20 h-28 rounded-lg overflow-hidden flex-shrink-0 bg-background-200">
                <img
                  src={webtoon.cover}
                  alt={webtoon.title}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2">
                    {webtoon.title}
                  </h3>
                  <p className="text-xs text-foreground-600 mt-1">{webtoon.author}</p>
                </div>
                <div className="flex items-center gap-3">
                  <span className="flex items-center gap-1 text-xs text-primary-500">
                    <i className="ri-star-fill text-xs"></i> {webtoon.rating}
                  </span>
                  <span className="text-xs text-foreground-500">{webtoon.views} 阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}